export enum Locale {
  'de-DE' = 'de-DE',
  'en-GB' = 'en-GB',
  'en-US' = 'en-US',
  'fr-FR' = 'fr-FR',
}

export enum PageResolverType {
  CATEGORY = 'category',
  CMS = 'cms',
  NOT_FOUND = 'not-found',
  PRODUCT = 'product',
}

export enum ProfileTab {
  MY_ORDERS = 'my-orders',
  MY_PROFILE = 'my-profile',
  MY_WISHLIST = 'my-wishlist',
}

export interface Country {
  ar?: string;
  bg?: string;
  cs?: string;
  currency_iso_code: Currency;
  da?: string;
  de?: string;
  el?: string;
  en?: string;
  eo?: string;
  es?: string;
  et?: string;
  eu?: string;
  fi?: string;
  fr?: string;
  hr?: string;
  hu?: string;
  hy?: string;
  iso_code: string;
  it?: string;
  ja?: string;
  ko?: string;
  lt?: string;
  nl?: string;
  no?: string;
  phone_number: CountryPhoneNumber;
  pl?: string;
  pt?: string;
  ro?: string;
  ru?: string;
  sk?: string;
  sl?: string;
  sr?: string;
  sv?: string;
  th?: string;
  uk?: string;
  zh_CN?: string;
  zh_TW?: string;
}

export interface CountryPhoneNumber {
  indicator: string;
  max_length: number;
  min_length: number;
}

export interface PageResolver {
  data: { alternate_slugs?: LocalizedValue; locale: Locale; slug: string };
  type: PageResolverType;
}
